function cov_8djcll8mf() {
  var path = "/app/src/components/credit-cards/index.tsx";
  var hash = "c3c064b014d3e52179dd34877f9d805968315c2d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/credit-cards/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c3c064b014d3e52179dd34877f9d805968315c2d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8djcll8mf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_8djcll8mf();
export { CreditCards } from './credit-cards';